import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CrossIcon from "../../../assets/images/lystfacelogos/CrossIcon.svg"
import DangerIcon from "../../../assets/images/lystfacelogos/DangerIcon.svg"
import SuccessIcon from "../../../assets/images/lystfacelogos/SuccessIcon.svg"





let prevToastId = null;


const CustomToast = ({ message, status, closeToast, time }) => {

    if (prevToastId !== null) {
        toast.dismiss(prevToastId);
    }

    const newToastId = toast.success(
        <>
            <div className="toast-layout-side1">
                <div className={`toast-layout-greentile ${status}`}></div>
                <div className="icon-container">
                    {status === 'success' ?
                        <img src={SuccessIcon} />
                        :
                        <img src={DangerIcon} />

                    }

                </div>
                <span className="layout-container-message">{message}</span>
                <img src={CrossIcon} />

            </div>
            ,
        </>,
        {
            position: 'top-center',
            className: "toast-layout-container",
            hideProgressBar: false,
            autoClose: time ? time : 5000,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        }
    );
    prevToastId = newToastId
};

export { CustomToast, ToastContainer };
